import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-four-hundred-four",
  templateUrl: "./four-hundred-four.component.html",
  styleUrls: ["./four-hundred-four.component.scss"],
})
export class FourHundredFourComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
